import { Product } from './product';
import { MoedaVendaEnum } from './enums/moeda-venda.enum';
import { TemplateCheckoutEnum } from './enums/template-checkout';
import { CupomDesconto } from './cupom-desconto';
import { PaisMercadoGlobalEnum } from './enums/pais-mercado-global.enum';
import { OrderBump } from './order-bump';
import {
  BillingAnchorType,
  BillingPeriodUnit,
} from './enums/billing-period-unit';

export interface Plano {
  id: string;
  productId: string;
  nome: string;
  descricao: string;
  valor: number;
  moeda: number;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
  billingConfig: BillingConfig;
  trialConfig: TrialConfig;
}

export interface BillingConfig {
  id: string;
  planoId: string;
  billingPeriodUnit: BillingPeriodUnit;
  billingPeriodCount: number;
  billingAnchorType: BillingAnchorType;
  billingAnchorDayOfMonth?: number;
  createdAt: string;
  updatedAt: string;
}

export enum TrialType {
    WithPayment = 1,
    Paid = 2
}

export interface TrialConfig {
  id: string
  planoId: string
  isTrialEnabled: boolean
  trialType: TrialType
  trialDays: any
  trialPrice: any
  createdAt: string
  updatedAt: string
}


export interface Checkout {
  id: string;
  status: number;
  moeda: MoedaVendaEnum;
  pais: string;
  paisEnum: PaisMercadoGlobalEnum;
  valor: number;
  linguagem: string;
  ip: string;
  valorParcela1x: number;
  valorParcela2x: number;
  valorParcela3x: number;
  valorParcela4x: number;
  valorParcela5x: number;
  valorParcela6x: number;
  valorParcela7x: number;
  valorParcela8x: number;
  valorParcela9x: number;
  valorParcela10x: number;
  valorParcela11x: number;
  valorParcela12x: number;
  metodosPagamento: string;
  maximoParcelas: number;
  expiresIn: string;
  produtoId: string;
  exibirEndereco: boolean;
  exibirCupomDesconto: boolean;
  afiliadoId?: string;
  produto: Product;
  subtotal: number;
  total: number;
  aplicouCupom: boolean;
  recorrencia: boolean;
  template: TemplateCheckoutEnum;
  corPrimariaCheckout: string;
  corSecundariaCheckout: string;
  cupomId?: string;
  imagemProduto?: string;
  backRedirect?: string;
  paginaObrigado?: string;
  pagamentoRecusado?: string;
  cupom: CupomDesconto;
  orderBumps: OrderBump[];
  orderBumpsAplicados: OrderBump[];
  checkoutConfig: CheckoutConfig;
  plano?: Plano;
  externalId?: string;
  hasFacebookPixel?: boolean;
  hasTikTokPixel?: boolean;
  bloqueadoParaVenda?: boolean;
  bloqueioVendaCodigo?: string | null;
  motivoBloqueioVenda?: string | null;
  stripeAccountCountry?: 'LEGACY' | 'BR';
}

export interface CheckoutConfig {
  id: string;
  productId: string;
  config: Config;
  nome?: string;
  active?: boolean;
  tipo?: 'nacional' | 'global';
}

export interface Config {
  checkoutData: CheckoutData;
  componentsAbove: DraggableComponents[];
  componentsBelow: DraggableComponents[];
}

export interface CheckoutHeaderModern {
  variant: CheckoutHeaderVariants;
  text: string;
  subtitle: string;
  originalPrice: number;
  image: string;
}

export interface CheckoutData {
  template: TemplateCheckoutEnum;
  orderSummary: OrderSummary;
  checkoutHeader: CheckoutHeader;
  checkoutHeaderModern: CheckoutHeaderModern;
  paymentMethods: PaymentMethods;
  purchaseButton: PurchaseButton;
  securePurchase: SecurePurchase;
}

export type OrderSummaryVariant = 'classic' | 'cut' | 'hole' | 'torn' | 'card';

export interface OrderSummary {
  variant: OrderSummaryVariant;
}

export type CheckoutHeaderVariants = 'classic' | 'photo';

export interface CheckoutHeader {
  text: string;
  image: string;
  variant: CheckoutHeaderVariants;
  subtitleColor: string;
}

export type PaymentMethodsVariant = 'classic' | 'minimalist' | 'ios';

export interface PaymentMethods {
  color: string;
  variant: PaymentMethodsVariant;
}

export interface PurchaseButton {
  color: string;
  background: string;
}

export interface SecurePurchase {
  color: string;
}

export type ComponentType =
  | 'text'
  | 'image'
  | 'divider'
  | 'social-proof'
  | 'timer'
  | 'purchase-button'
  | 'secure-purchase'
  | 'payment-methods'
  | 'order-summary'
  | 'checkout-header'
  | 'advantages'
  | 'custom-html';

export interface DraggableComponents {
  id: string;
  type: ComponentType;
  order: number;
  style: Style;
  content: string;
  position: string;
  configurations: Configurations;
}

export interface Link {
  id: string;
  start: number;
  end: number;
  href: string;
  newTab: boolean;
}

export interface Style {
  color: string;
  fontSize: number;
  textAlign: string;
  fontFamily: string;
  fontWeight: string;
  links: Link[];
}

export interface Configurations {
  timer: Timer;
  advantages: Advantages;
  testimonial: Testimonial;
}

export interface Timer {
  text: string;
  time: number;
  textColor: string;
  background: string;
}

export interface Advantages {
  icon: string;
  color: string;
  title: string;
  subtitle: string;
}

export interface Testimonial {
  name: string;
  text: string;
  avatar: string;
  rating: number;
  audioUrl: string;
  instagram: Instagram[];
  testimonialType: string;
}

export interface Instagram {
  name: string;
  time: string;
  avatar: string;
  videoUrl: string;
}
